import { CloseIcon } from 'components/uiIcons';
import { Stack, IconButton } from 'components/ui';
import { CenterModal, ModalContent, ModalStack } from 'components/styles_components/modal';

const Modal = ({ handleClose, children }) => {
  return (
    <CenterModal
      open={true}
      onClose={handleClose}
    >
      <ModalContent
        sx={{
          width: { xs: '100vw', lg: '90vw' },
          height: { xs: '100vh', lg: '90vh' },
        }}
      >
        <Stack direction="row" justifyContent="flex-end">
          <IconButton aria-label="close" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
        <ModalStack>{children}</ModalStack>
      </ModalContent>
    </CenterModal>
  );
};

export default Modal;
